export const ECB_DOMAINS = ['ecb.infomedia.eu', 'ecb.dev.infomedia.eu']
